<template>
  <!--对话框 获取员工列表-->
  <el-dialog :visible="isShow" :width="width" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" :show-close="false">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-user-solid"></i> 名片</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <div class="dialog-search-container">
      <el-input size="small" placeholder="请输入姓名" v-model="queryData.name">
        <template slot="prepend">搜索：</template>
        <el-button slot="append" icon="el-icon-search" @click="searchHandler"></el-button>
      </el-input>
    </div>
    <div class="dialog-main-container">
      <el-table :data="ds" size="mini" height="480" style="width: 100%;" stripe border header-row-class-name="list-header-row" row-class-name="list-row">
        <el-table-column prop="name" label="姓名" width="150" align="center"></el-table-column>
        <el-table-column prop="phone" label="电话" width="150" align="center"></el-table-column>
        <el-table-column prop="create_time" label="注册时间" align="center"></el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination :current-page="queryData.pageIndex" :page-size="queryData.pageSize" layout="prev, pager, next" :total="queryData.dataCount" @size-change="pageSizeChange" @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<style scoped>
.dialog-title-container > i {
  float: right;
  font-size: 18px;
  color: #0f0e0c;
  cursor: pointer;
}
.dialog-search-container {
  position: relative;
}
.dialog-main-container {
  position: relative;
}
</style>
<script>
import apis from './module.apis.js'
export default {
  name: 'EzzDialogEmployee',
  props: {
    parent: {
      type: Object,
      default: () => null
    },
    width: {
      type: String,
      default: '50%'
    }
  },
  data: function () {
    return {
      isShow: false,
      ds: [],
      queryData: {
        name: '',
        id: '',
        pageIndex: 1, // 页码
        pageSize: 10, // 每页条数
        dataCount: 1
      }
    }
  },
  mounted: function () {},
  methods: {
    loadData: function () {
      let _this = this
      _this.post(apis.getmember, _this.queryData, function (res) {
        let _json = res.data
        _this.ds = _json.dataList
        _this.queryData.dataCount = _json.dataCount
      })
    },
    open: function (row) {
      this.queryData.id = row.user_id
      this.loadData()
      this.isShow = true
    },
    close: function () {
      this.isShow = false
    },
    checkBack: function (_index) {
      let id = this.ds[_index].id
      let name = this.ds[_index].name
      let company_name = this.ds[_index].company_name
      let company_id = this.ds[_index].company_id
      this.parent.acceptCards(id, name, company_name, company_id)
      this.isShow = false
    },
    pageChange: function (pageIndex) {
      this.queryData.pageIndex = pageIndex
      this.loadData()
    },
    pageSizeChange: function (pageSize) {
      this.queryData.pageIndex = 1
      this.queryData.pageSize = pageSize
      this.loadData()
    },
    // 搜索事件
    searchHandler: function () {
      this.queryData.pageIndex = 1
      this.ds = []
      this.loadData()
    }
  }
}
</script>
